export enum AgentRole {
  Director = 'director',
  SalesAgent = 'salesagent',
  Admin = 'admin',
}

export enum StaffRole {
  BusinessManager = 'businessmanager',
  AdminManager = 'adminmanager',
  MarketingExpert = 'marketingexpert',
  ListingsContributor = 'listingscontributor',
  LaunchContributor = 'launchcontributor',
  ContractsContributor = 'contractscontributor',
  TransactionsContributor = 'transactionscontributor',
  FinanceContributor = 'financecontributor',
  WorkflowContributor = 'workflowcontributor',
  Executive = 'executive',
  SuperAdmin = 'superadmin',
}
